import { type ReactNode } from 'react';
import { Classes } from '@blueprintjs/core';
import cx from 'clsx';

import './styles.scss';

type TableProps = Readonly<{
  className?: string;
  children?: ReactNode;
}>;

export const Table = ({ className, children }: TableProps) => (
  <table className={cx(Classes.HTML_TABLE, Classes.HTML_TABLE_STRIPED, Classes.INTERACTIVE, className, 'Table')}>
    {children}
  </table>
);

type TableCellProps = Readonly<{
  children?: ReactNode;
  className?: string;
  align?: 'left' | 'center' | 'right';
}>;

export const TableCell = ({ align, className, children }: TableCellProps) => (
  <td className={cx(className, 'TableCell', `TableCell-${align}`)}>{children}</td>
);
